<template>
    <div class="orderProduct">
        <div class="row">
            <div class="col-12 col-xs-12">
                <div class="productName h4">{{productItem.name}}</div>
            </div>
            <div class="col-md-3">
                <api-image v-bind:images="images"></api-image>
            </div>
            <div class="optionsUI col-md-6">
                <div class="descr">
                    {{productItem.description}}
                </div>
                <div class="option" v-for="(option,idx) in optionNames" :key="idx">
                    {{option}}:
                    <div class="optsList">
                    <span class="oVal" v-for="(value,i) in options[idx]" :key="i"
                          v-bind:class="(value.act) ? 'active' : ''"
                          v-on:click="toggleOption(idx, value.code)">
                        {{value.name}}
                    </span>
                    </div>
                </div>
                <div v-if="optionNames.length==0 && addons.length" class="addons">
                    <div class="addon" v-for="(addon,i) in addons" :key="i" @click="addAddonToBasket(addon)">
                        <div class="aImg">
                            <api-image
                                    v-bind:images="addon.images"
                                    v-bind:preset="'sylius_shop_product_thumbnail'">
                            </api-image>
                        </div>
                        <div class="aText">
                            {{addon.name}}
                        </div>
                        <a class="btn btn-primary btn-circle btn-circle-sm" ><i class="fa fa-plus"></i></a>
                    </div>
                </div>
            </div>
            <div class="orderUI col-md-3">
                <div class="price">
                    <div class="amount">
                        {{totalPrice()|formatMoney}}
                    </div>
                    <a role="button" class="btn btn-primary" @click="addToBasket"><i class="fa fa-plus"></i> add to order</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApiImage from "./Image";

    export default {
        name: 'Product',
        props: {
            productItem: Object
        },
        data: function () {
            return {
                options: [],
                addons: [],
                optionNames: [],
                images: [],
                settings: {},
                variantCode: null
            }
        },
        components: {
            ApiImage
        },
        mounted() {
            this.images = this.productItem.images
            this.prepareOptions()
            this.prepareAddons()
            this.settings = window.localStorage
        },
        methods: {
            prepareOptions: function () {
                this.options = new Array(this.productItem.variants[Object.keys(this.productItem.variants)[0]].axis.length)//.fill([]);
                for(let i=0; i<this.options.length; i++) {
                    this.options[i] = []
                }
                for(let index in this.productItem.variants) {
                    let variant = this.productItem.variants[index];
                    for(let i=0; i < variant.axis.length; i++) {
                        let option = {
                            code: variant.axis[i],
                            name: variant.nameAxis[variant.axis[i]],
                            act: false
                        }
                        this.pushUnique(this.options[i], option)
                    }
                }
                this.getOptionNames();
            },

            prepareAddons: function() {
                if (this.productItem.associations.CMP ) {
                    for(let i=0; i<this.productItem.associations.CMP.length; i++) {
                        if ( Object.keys(this.productItem.associations.CMP[i].variants).length < 2 ) {
                            this.addons.push(
                                this.productItem.associations.CMP[i]
                            )
                        }
                    }
                }
            },

            pushUnique: function (arr, obj) {
                let existingCodes = arr.map((obj) => obj.code);
                if (! existingCodes.includes(obj.code)) {
                    arr.push(obj);
                } else {
                    arr.forEach((element, index) => {
                        if (element.code === obj.code) {
                            arr[index] = obj;
                        }
                    });
                }
            },

            getOptionNames: function() {
                for (let o = 0; o < this.options.length; o++) {
                    let longestPrefix = '';
                    if (this.options[o].length > 0) {
                        longestPrefix = this.options[o][0].name;

                        for (let i = 1; i < this.options[o].length; i++) {
                            for (let j = 0; j < longestPrefix.length; j++) {
                                if (this.options[o][i].name[j] != longestPrefix[j]) {
                                    longestPrefix = longestPrefix.slice(0, j);
                                    break;
                                }
                            }
                        }
                        for (let i = 0; i < this.options[o].length; i++) {
                            this.options[o][i].name = this.options[o][i].name.replace(longestPrefix, '');
                        }
                        this.optionNames.push(longestPrefix.trim());
                    }
                    if (!this.settings[this.options[o]]) {
                        this.options[o][0].act=true
                    }
                }
            },
            toggleOption : function (idx, code) {
                for(let i=0; i<this.options[idx].length; i++) {
                    if (this.options[idx][i].code == code) {
                        this.options[idx][i].act = true
                    } else {
                        this.options[idx][i].act = false
                    }
                }
                this.$forceUpdate()
            },

            totalPrice: function () {
                let cVariant = new Array(this.options.length)
                for(let i=0; i<this.options.length; i++) {
                    for(let j=0; j<this.options[i].length; j++) {
                        if (this.options[i][j].act) {
                            cVariant[i] = this.options[i][j].code
                        }
                    }
                }
                for(let index in this.productItem.variants) {
                    let variant = this.productItem.variants[index];
                    let thisVariat = true;
                    for (let i=0; i<cVariant.length; i++) {
                        if (cVariant[i]!=variant.axis[i]) {
                            thisVariat = false;
                        }
                    }
                    if (thisVariat) {
                        if (variant.images.length) {
                            this.images = variant.images
                        } else {
                            this.images = this.productItem.images
                        }
                        this.variantCode = variant.code

                        return variant.price.current;
                    }
                }
                return 0;
            },

            addToBasket: function () {
                if ( this.options.length ) {
                    this.$store.dispatch('addProduct', [this.productItem.code, this.variantCode])
                } else {
                    this.$store.dispatch('addProduct', [this.productItem.code])
                }
            },

            addAddonToBasket: function ( product ) {
                console.log(product)

                if (product.variants.length > 1) {
                    console.log('Valiadns addons not implemented yet')
                    return
                } else {
                    this.$store.dispatch('addProduct', [product.code] )
                }
            }
        },
    }
</script>
